// extracted by mini-css-extract-plugin
module.exports = {"backColor":"score-tips_backColor_d_H9d"};